import Badge from 'components/badge/badge';
import CompanyAction from 'components/companies/CompanyAction';
import useText from 'hooks/useText';
import MobileListCard from './MobileListCard';

/**
 * A company of the list on a phone (pages/companies/companiesItems.js
 * describes it): its category, its next action, the date of its tab; a lost
 * company says why and when to try again.
 */
const CompanyMobileCard = ({ company, tab, isSelected, onOpen }) => {
  const { text } = useText('companies');
  const lost = tab === 'lost';
  let metaItems = [];
  if (lost) {
    metaItems = [
      { label: text('columnLostOn'), value: company.lostOn },
      { label: text('columnReason'), value: company.lostReason },
    ];
  } else if (company.since) {
    metaItems = [{ label: tab === 'prospects' ? '' : text('columnClientSince'), value: company.since }];
  }
  const next = lost ? company.relaunchOn && company.relaunch : company.action;
  return (
    <MobileListCard
      title={company.name}
      subtitle={[company.department, company.groups].filter(Boolean).join(' · ')}
      isSelected={isSelected}
      onClick={() => onOpen(company._id)}
      topRightBadge={company.category ? <Badge type={company.category.badge}>{company.category.label}</Badge> : null}
      badge={next ? <CompanyAction>{next}</CompanyAction> : null}
      metaItems={metaItems}
    />
  );
};

export default CompanyMobileCard;
